import {RouterLocation} from '@store/@types/util/ReactRouter';
import React from 'react';
import AuthStore from 'stores/AuthStore';
import connectToStores from 'alt-utils/lib/connectToStores';
import {initializeFullstory} from 'utils/fullstory';
import {initializeGainsightPX} from 'utils/gainsightPX';

interface ThirdPartyInitProps {
  location: RouterLocation;
}

/**
 * Initialize setup for third-party trackers and such.
 */
@connectToStores
class ThirdPartyInit extends React.Component<
  ThirdPartyInitProps & ReturnType<typeof ThirdPartyInit.getPropsFromStores>
> {
  static getStores() {
    return [AuthStore];
  }

  static getPropsFromStores() {
    return {
      sessionUser: AuthStore.getState().user,
    };
  }

  componentDidUpdate(prevProps) {
    const {sessionUser} = this.props;
    if (sessionUser !== prevProps.sessionUser) {
      initializeFullstory(sessionUser);
    }
    if (sessionUser !== prevProps.sessionUser) {
      initializeGainsightPX(sessionUser);
    }
  }

  render() {
    return null;
  }
}

export default ThirdPartyInit as unknown as React.FC<ThirdPartyInitProps>;
